"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = exports.triggerCommonClasses = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const select_1 = require("@base-ui/react/select");
const MosaicIcon_1 = require("../MosaicIcon");
const src_1 = require("src");
const SelectRoot = (_a) => {
    var { children, onChange } = _a, props = tslib_1.__rest(_a, ["children", "onChange"]);
    const handleValueChange = (value) => {
        if (typeof value !== 'string')
            return;
        onChange(value);
    };
    return ((0, jsx_runtime_1.jsx)(select_1.Select.Root, Object.assign({ modal: false, onValueChange: handleValueChange }, props, { children: children })));
};
exports.Select = SelectRoot;
exports.triggerCommonClasses = 'group flex justify-between items-center gap-2 data-disabled:bg-fill-primary bg-fill-primary hover:bg-fill-primary-hovered border border-primary p-[7px] min-h-10 rounded-2xl data-disabled:border-disabled data-disabled:cursor-default disabled:border-disabled disabled:cursor-default pl-4';
const SelectTrigger = (_a) => {
    var { className } = _a, props = tslib_1.__rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsxs)(select_1.Select.Trigger, Object.assign({ className: (0, src_1.cn)(exports.triggerCommonClasses, className) }, props, { children: [(0, jsx_runtime_1.jsx)(select_1.Select.Value, { className: "text-primary body-md group-data-disabled:text-disabled" }), (0, jsx_runtime_1.jsx)(select_1.Select.Icon, { className: "flex", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "expand-more", className: "group-data-disabled:text-disabled group-data-popup-open:rotate-180 transition-transform" }) })] })));
};
const SelectPopup = (_a) => {
    var { children, popupRef, className } = _a, props = tslib_1.__rest(_a, ["children", "popupRef", "className"]);
    return ((0, jsx_runtime_1.jsx)(select_1.Select.Portal, { children: (0, jsx_runtime_1.jsx)(select_1.Select.Positioner, { alignItemWithTrigger: false, align: "start", className: "z-popout", children: (0, jsx_runtime_1.jsx)(select_1.Select.Popup, Object.assign({ className: (0, src_1.cn)('shadow-md bg-fill-primary p-2xs rounded-3xl min-w-(--anchor-width) max-h-[min(22rem,var(--available-height))] overflow-auto overscroll-contain scroll-p-2', className), ref: popupRef }, props, { children: children })) }) }));
};
const SelectList = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (0, jsx_runtime_1.jsx)(select_1.Select.List, Object.assign({}, props, { children: children }));
};
const SelectItem = (_a) => {
    var { className, label } = _a, props = tslib_1.__rest(_a, ["className", "label"]);
    return ((0, jsx_runtime_1.jsx)(select_1.Select.Item, Object.assign({ className: "p-2xs rounded-2xl data-selected:bg-fill-primary-hovered hover:bg-fill-primary-hovered focus:bg-fill-primary-hovered" }, props, { children: (0, jsx_runtime_1.jsx)(select_1.Select.ItemText, { children: label }) })));
};
SelectRoot.Trigger = SelectTrigger;
SelectRoot.Popup = SelectPopup;
SelectRoot.List = SelectList;
SelectRoot.Item = SelectItem;
